import { Container, Row, Col, Tab } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
import { ProjectCard } from "./ProjectCard";
import "animate.css";
import plus from "../assets/img/plus-light.png";
import chat from "../assets/img/chat-light.png";
import oxy from "../assets/img/oxygen-light.png";
import spar from "../assets/img/sparrow-light.png";
import crab from "../assets/img/crabby-light.png";
import zero from "../assets/img/zero-light.png";
import term from "../assets/img/term-light.png";
import imcom from "../assets/img/img-com-light.png";
import robin from "../assets/img/robin-light.png";

import colorSharp2 from "../assets/img/color-sharp2.png";

export const Projects = () => {
	const projects = [
		{
			title: "Plus",
			description: "CPP Utility Application",
			imgUrl: plus,
			projUrl: "https://github.com/Eshanatnight/plus",
		},
		{
			title: "WebRTC Chat",
			description: "A WebRTC Chat Application written in Rust",
			imgUrl: chat,
			projUrl: "https://github.com/Eshanatnight/WebRTC-Chat",
		},
		{
			title: "Oxygen",
			description: "A Voice Recorder Application written in Rust",
			imgUrl: oxy,
			projUrl: "https://github.com/Eshanatnight/Oxygen",
		},
		{
			title: "Sparrow",
			description: "A Stack Based Programming Language written in CPP",
			imgUrl: spar,
			projUrl: "https://github.com/Eshanatnight/Sparrow",
		},
		{
			title: "Crabby",
			description: "A Simple TUI Game written in Rust",
			imgUrl: crab,
			projUrl: "https://github.com/Eshanatnight/Crabby",
		},
		{
			title: "ZeroBuild",
			description: "Header only library for writing build recipes in C",
			imgUrl: zero,
			projUrl: "https://github.com/Eshanatnight/ZeroBuild",
		},
		{
			title: "Terminal-Pastebin",
			description: "A Pastebin Client written in Rust",
			imgUrl: term,
			projUrl: "https://github.com/Eshanatnight/terminal-pastebin",
		},
		{
			title: "Image Compressors",
			description: "Imgae Compressors tools",
			imgUrl: imcom,
			projUrl:
				"https://github.com/Eshanatnight/EternalSunshineOfThePictorialMind",
		},
		{
			title: "Robin",
			description: "A toy web rendering engine written in Rust",
			imgUrl: robin,
			projUrl: "https://github.com/Eshanatnight/robin",
		},
	];

	return (
		<section className="project" id="project">
			<Container>
				<Row>
					<Col size={12}>
						<TrackVisibility>
							{({ isVisible }) => (
								<div
									className={
										isVisible
											? "animate__animated animate__fadeIn"
											: ""
									}>
									<h2>Projects</h2>
									<p>Some of the Projects I have worked on</p>
									<Tab.Container
										id="projects-tabs"
										defaultActiveKey="first">
										<Tab.Content
											id="slideInUp"
											className={
												isVisible
													? "animate__animated animate__slideInUp"
													: ""
											}>
											<Tab.Pane eventKey="first">
												<Row>
													{projects.map(
														(project, index) => {
															return (
																<ProjectCard
																	key={index}
																	{...project}
																/>
															);
														}
													)}
												</Row>
											</Tab.Pane>
										</Tab.Content>
									</Tab.Container>
								</div>
							)}
						</TrackVisibility>
					</Col>
				</Row>
			</Container>
			<img className="background-image-right" src={colorSharp2} alt=""></img>
		</section>
	);
};
